import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { isEmpty } from 'ramda'
import { ExcursionCard } from './ExcursionCard/ExcursionCard'
import styles from './Excursions.module.css'

export function Excursions() {
  const intl = useIntl()
  const { description, excursions } = useCMSPageField('DestinationPage.excursions')
  const publicationCode = useConfiguration('publicationCode')
  if (isEmpty(excursions)) {
    return null
  }
  const shouldShowPricesIfEmpty = !PublicationCodes.isElizaPublicationCode(publicationCode)
  return (
    <section>
      <SectionTitle>{intl.formatMessage({ id: 'destination_excursions_title' })}</SectionTitle>
      <RichText className={styles.description} innerHTML={description} />
      <div className={styles.grid}>
        {excursions?.map(excursion => (
          <ExcursionCard
            key={excursion.title}
            title={excursion.title}
            description={excursion.description}
            mediaSrc={excursion.image}
            price={excursion.price}
            showPriceIfEmpty={shouldShowPricesIfEmpty}
          />
        ))}
      </div>
    </section>
  )
}
